import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { Button, Typography } from "@mui/material";
import { useDialog } from "../../../../../common/components/dialog/useDialog";
import CreateDeviceMakeDialog from "./CreateDeviceMakeDialog";

const CreateDeviceMakeDialogContainer = (): JSX.Element => {
  const { open, handleDialogOpen, handleDialogClose } = useDialog();

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        startIcon={<AddOutlinedIcon />}
        onClick={handleDialogOpen}
      >
        <Typography variant="buttonMedium">Create Device Make</Typography>
      </Button>
      {open && (
        <CreateDeviceMakeDialog open={open} handleClose={handleDialogClose} />
      )}
    </>
  );
};

export default CreateDeviceMakeDialogContainer;
